'use strict';

module.exports = function isPrimitive(value) {
	return value === null || (typeof value !== 'function' && typeof value !== 'object');
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/es-abstract/helpers/isPrimitive.js
 ** module id = 421
 ** module chunks = 0
 **/